angular.module('unica_location.location_controllers')

.controller('LocationCreateController', function(
	$rootScope, $scope, $state,
	LocationCreateService
) {

	$scope.pageTitle = 'Aggiungi Location';

	$scope.locationData = {};

	$scope.map.zoom = 6;

	$scope._saveLocation = function() {
		LocationCreateService
			.create( $scope.locationData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Location aggiunta con successo!', '');
					$state.go('app.location.list');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.saveLocation = function () {
		$scope.showLoader();

		if ( $scope.locationData.is_virtual ) {
			$scope._saveLocation();
		} else {
			$scope.geocoder.geocode({
				address: $scope.locationData.address
			}, function(responses) {
				if (responses && responses.length > 0) {
					$scope.locationData.zoom      = $scope.map.zoom;
					$scope.locationData.latitude  = responses[0].geometry.location.lat();
					$scope.locationData.longitude = responses[0].geometry.location.lng();
					$scope._saveLocation();
				} else {
					$scope.hideLoader();
					$rootScope.showErrorMsg('Indirizzo non valido');
				}
			}, function ( err ) {
				$scope.hideLoader();
				console.log(err);
				$rootScope.showErrorMsg('Indirizzo non valido [1]');
			});
		}
	};

});




